import { Component, type ReactNode } from 'react';

import { toNoemirError } from '../contracts/errors';
import type { CoreErrorState } from '../contracts/errors';

interface AppErrorBoundaryProps {
  readonly children: ReactNode;
}

interface AppErrorBoundaryState {
  readonly error: CoreErrorState | null;
}

export class AppErrorBoundary extends Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
  override state: AppErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: unknown): AppErrorBoundaryState {
    return { error: toNoemirError(error).state };
  }

  override componentDidCatch(): void {
    // Intentionally no remote logging in v0.1. The boundary keeps the process recoverable.
  }

  override render(): ReactNode {
    if (this.state.error !== null) {
      return (
        <main className="startup-state startup-error" aria-labelledby="fatal-error-title">
          <p className="surface-eyebrow">Fatal boundary</p>
          <h1 id="fatal-error-title">Noemir could not initialize.</h1>
          <p>{this.state.error.message}</p>
          <code>{this.state.error.code}</code>
        </main>
      );
    }

    return this.props.children;
  }
}
